import React, { Component } from 'react';
import CountUp from 'react-countup';

class Rankings extends Component {
  getChart() {
    if(this.props.ranks !== undefined && this.props.ranks.team !== "" && this.props.ranks.team !== 0) {
      return (
        <div>
        <div className="section-title">{this.props.yearFilter} NCAA Rankings</div>
        <div className="rankingsBoxM">
          <div className="rankboxM">
            <div className="rankbox-title">RANK</div>
            <div className="rankbox-rank">
              <CountUp
                className="custom-count"
                start={99}
                end={Number(this.props.ranks.team)}
                duration={1}
                useEasing={true}
              />
            </div>
          </div>
          <div className="ranksboxM">
            <div className="rank-floorM">
              <p className="rank-title">Floor</p>
              <p className="rank-rank">
                <CountUp
                  className="custom-count"
                  start={99}
                  end={Number(this.props.ranks.floor)}
                  duration={1.25}
                  useEasing={true}
                />
              </p>
            </div>
            <div className="rank-phorseM">
              <p className="rank-title">PHorse</p>
              <p className="rank-rank">
                <CountUp
                  className="custom-count"
                  start={99}
                  end={Number(this.props.ranks.phorse)}
                  duration={1.5}
                  useEasing={true}
                />
              </p>
            </div>
            <div className="rank-ringsM">
              <p className="rank-title">Rings</p>
              <p className="rank-rank">
                <CountUp
                  className="custom-count"
                  start={99}
                  end={Number(this.props.ranks.rings)}
                  duration={1.75}
                  useEasing={true}
                />
              </p>
            </div>
            <div className="rank-vaultM">
              <p className="rank-title">Vault</p>
              <p className="rank-rank">
                <CountUp
                  className="custom-count"
                  start={99}
                  end={Number(this.props.ranks.vault)}
                  duration={2}
                  useEasing={true}
                />
              </p>
            </div>
            <div className="rank-pbarsM">
              <p className="rank-title">PBars</p>
              <p className="rank-rank">
                <CountUp
                  className="custom-count"
                  start={99}
                  end={Number(this.props.ranks.pbars)}
                  duration={1.75}
                  useEasing={true}
                />
              </p>
            </div>
            <div className="rank-highbarM">
              <p className="rank-title">Highbar</p>
              <p className="rank-rank">
                <CountUp
                  className="custom-count"
                  start={99}
                  end={Number(this.props.ranks.highbar)}
                  duration={2}
                  useEasing={true}
                />
              </p>
            </div>
          </div>
        </div>
        </div>
      );
    } else {
      return <span></span>;
    }
  }
  render() {
    return (
      <div>
        {this.getChart()}
      </div>
    );
  }
}

export default Rankings;
